import { Page } from '@/layouts'
import { Link } from '@/style-guide'
import { Button, Typography } from 'antd'
import { useHistory } from 'react-router-dom'

export const BookingAlreadyExists = ({ booking }) => {
  const history = useHistory()
  const redirectUrl = new URLSearchParams(location.search).get('redirect_url')
  return (
    <Page>
      <div className="content"
      style={{
          display: 'flex',
          flexDirection: 'column', // Stack items vertically
          justifyContent: 'center', // Center vertically
          alignItems: 'center',     // Center horizontally
          textAlign: 'center',      // Center the text inside the elements
          minHeight: '60vh',        // Make the container tall enough to see the centering
      }}
      >
        <Typography.Text>You have already booked this event.</Typography.Text>
        <div className="margin-top-10">
          <Button
            onClick={() => {
              if (booking?.status == 'pending')
                history.push(`/dashboard/booking-requests/${booking?._id}`)
              else history.push(`/dashboard/confirmed-events/${booking?._id}`)
            }}
            type="primary"
          >
            Manage your booking
          </Button>
        </div>
        {redirectUrl && (
          <div className="margin-top-10">
            <Button
              type="link"
              onClick={() => (window.location.href = redirectUrl)}
            >
              Go back
            </Button>
          </div>
        )}
      </div>
    </Page>
  )
}
